export default __webpack_public_path__ + "static/media/464f91b9379806cfb80ca83ed573909f.bda7a5f2.svg";